import { useContext } from 'react';

import { ActiveTeamContext } from './ActiveTeamProvider';

export const useActiveTeamId = () => {
  const context = useContext(ActiveTeamContext);
  if (!context) {
    throw new Error('useActiveTeamId should be used within an ActiveTeamProvider');
  }
  return context;
};
